import { connect } from 'react-redux';
import React from 'react';
import { KBButton, KBPopover, KBForm } from 'components';
import intl from 'react-intl-universal';
import { renderKBInput, renderKBSelect, withReduxFormFieldProps } from 'components/formAdapters/reduxFormAdapters';
import { Field, reduxForm } from 'redux-form';

var LockerForm = class extends React.Component {render()
  {
    const {
      fields: { name, device_id, status },
      handleSubmit,
      submitting,
      LOCKER_STATUS } =
    this.props;
    return (
      <KBForm
      type="reduxForm"
      onSubmit={handleSubmit(this.createLocker)}>

        <header className="kb-form-header">
          <h2 className="header-title"> 添加储物柜 </h2>
          <i
          className="iconfont header-close icon-cancel"
          onClick={KBPopover.close} />

        </header>
        <div className="kb-form-container">
          <div className="kb-row">
            <Field name="name" component={renderKBInput}
            className="kb-form-group kb-form-c18 kb-form-alone"

            title="储物柜名称"
            isRequired={true} />

          </div>
          <div className="kb-row">
            <Field name="device_id" component={renderKBInput}
            className="kb-form-group kb-form-c18 kb-form-alone"

            title="储物柜ID"
            isRequired={true} />

          </div>
          <div className="kb-row">
            <Field name="status" component={renderKBSelect}
            defaultValue=" "
            className="kb-form-group kb-div-c18 kb-form-alone"
            title="状态"

            arrayData={LOCKER_STATUS} />

          </div>
          <div className="kb-row fixed-form-btn">
            <span className="cancel-btn" onClick={KBPopover.close}>
              {' '}
              取消{' '}
            </span>
            <KBButton
            className="certain-btn"
            type="submit"
            submitting={submitting}>

              确定
            </KBButton>
          </div>
        </div>
      </KBForm>);

  }};


function mapStateToProps(state) {
  const LOCKER_STATUS = [
  {
    id: 'normal',
    name: '正常' },

  {
    id: 'disabled',
    name: '停用' },

  {
    id: 'damaged',
    name: '损坏' }];


  return {
    LOCKER_STATUS };

}

function mapDispatchToProps(dispatch) {
  return {};
}

const validate = values => {
  const errors = {};

  return errors;
};

const LEGACY_FORM_FIELDS = [
  "name",
  "status",
  "device_id"
];

const formConfig = {
  form: 'LockerForm',
  validate: validate,
  touchOnBlur: false };


LockerForm = connect(mapStateToProps, mapDispatchToProps)(reduxForm(formConfig)(withReduxFormFieldProps('LockerForm', LEGACY_FORM_FIELDS)(LockerForm)));

export default LockerForm;
